class SyncedCartDrawer {
  constructor() {
    this.drawer = document.getElementById('SyncedCartDrawer');
    this.overlay = document.getElementById('SyncedCartDrawerOverlay');
    this.closeBtn = document.getElementById('SyncedCartDrawerClose');
    this.itemsContainer = document.getElementById('SyncedCartDrawerItems');
    this.totalEl = document.getElementById('SyncedCartDrawerTotal');
    this.checkoutBtn = document.getElementById('SyncedCartDrawerCheckout');
    this.cartIcon = document.querySelector('#cart-icon-bubble');

    this.init();
  }

  init() {
    // Open / close drawer
    if (this.cartIcon) this.cartIcon.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keyup', (e) => { if(e.key === 'Escape') this.close(); });
    this.checkoutBtn.addEventListener('click', () => window.location.href='/cart');

    // Auto open drawer after add to cart
document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
  form.addEventListener('submit', () => {
    setTimeout(() => {
      this.fetchCart();
      this.open();
    }, 800); // așteaptă 800ms ca tema să finalizeze adăugarea
  });
});

    // Listen for any cart updates via AJAX (including theme native events)
    document.addEventListener('cart:updated', () => this.fetchCart());

    // Initial fetch
    this.fetchCart();
  }

  async fetchCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    this.renderItems(cart.items);
    this.updateTotal(cart.total_price);
    this.updateBadge(cart.item_count);
  }

  renderItems(items) {
    this.itemsContainer.innerHTML = '';
    if(!items.length){ this.itemsContainer.innerHTML='<p>Coșul este gol.</p>'; return; }

    items.forEach(item => {
      const div = document.createElement('div');
      div.classList.add('drawer-item');
      div.innerHTML = `
        <img src="${item.image}" alt="${item.title}">
        <div class="drawer-item-details">
          <p>${item.title}</p>
          <div class="quantity-controls">
            <button class="qty-minus" data-id="${item.id}">-</button>
            <input type="number" min="0" value="${item.quantity}" data-id="${item.id}">
            <button class="qty-plus" data-id="${item.id}">+</button>
            <button class="remove-item" data-id="${item.id}">❌</button>
          </div>
          <p>${this.formatMoney(item.line_price)}</p>
        </div>`;
      this.itemsContainer.appendChild(div);
    });

    // Bind events
    this.itemsContainer.querySelectorAll('.qty-plus').forEach(btn => btn.addEventListener('click', e=>this.changeQty(e,1)));
    this.itemsContainer.querySelectorAll('.qty-minus').forEach(btn => btn.addEventListener('click', e=>this.changeQty(e,-1)));
    this.itemsContainer.querySelectorAll('.remove-item').forEach(btn => btn.addEventListener('click', e=>this.removeItem(e)));
  }

  async changeQty(e, delta){
    const id = e.target.dataset.id;
    const input = this.itemsContainer.querySelector(`input[data-id="${id}"]`);
    let qty = parseInt(input.value)+delta;
    if(qty<0) qty=0;
    input.value=qty;

    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id,quantity:qty})
    });
    this.fetchCart();
  }

  async removeItem(e){
    const id = e.target.dataset.id;
    await fetch('/cart/change.js',{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id,quantity:0})});
    this.fetchCart();
  }

  open(){ this.drawer.classList.add('active'); this.overlay.classList.add('active'); }
  close(){ this.drawer.classList.remove('active'); this.overlay.classList.remove('active'); }

  updateTotal(cents){ this.totalEl.textContent=this.formatMoney(cents); }

  updateBadge(count){
    const badge = document.querySelector('#cart-icon-bubble .cart-count');
    if(badge) badge.textContent = count || 0;
  }

  formatMoney(cents){ return (cents/100).toLocaleString('ro-RO',{style:'currency',currency:'RON'}); }
}

// Init
document.addEventListener('DOMContentLoaded', ()=>new SyncedCartDrawer());
